import { useMemo } from 'react';

/**
 * Default owner for a new project item or action item.
 * The logged-in user when they are on the project team; otherwise the project owner, then a project manager.
 * Returns an empty string when none of them is on the team, so the owner must be chosen.
 * @param users - project team members
 * @param projectOwnerId - the project's owner id
 * @param loggedInUserId - the logged-in user's Keycloak subject, which is their user id
 */
export const useDefaultItemOwner = (
  users: ReadonlyArray<{ id: string; role?: string }>,
  projectOwnerId: string | null | undefined,
  loggedInUserId: string | null | undefined,
): string => {
  const currentUserId = loggedInUserId || '';
  const isProjectMember = users.some((user) => user.id === currentUserId);

  return useMemo(() => {
    if (isProjectMember) return currentUserId;
    if (projectOwnerId && users.some((user) => user.id === projectOwnerId)) return projectOwnerId;
    return users.find((user) => user.role?.toLowerCase() === 'project manager')?.id ?? '';
  }, [isProjectMember, currentUserId, users, projectOwnerId]);
};
